<template>
  <div :class="$style.container">
    <label :class="$style.label">
      <input
        v-model="OptionalValidationModel"
        :class="$style.inputRadio"
        :name="config.name"
        type="radio"
        :value="true"
        @change="handleInput(true)"
      >
      <span :class="$style.labelName">
        True
      </span>
    </label>
    <label :class="[$style.label, $style.rightRadio]">
      <input
        v-model="OptionalValidationModel"
        :class="$style.inputRadio"
        :name="config.name"
        type="radio"
        :value="false"
        @change="handleInput(false)"
      >
      <span :class="$style.labelName">
        False
      </span>
    </label>
  </div>
</template>

<script>
import ValidatorMixin from 'client/components/FormValidation/mixins/ValidatorMixin';

export default {
  name: 'BooleanAttributeInput',

  inject: ['$validator'],

  mixins: [ValidatorMixin],
};
</script>
<style module>
.container {
  margin-top: 10px !important;
}

.label,
.inputRadio {
  cursor: pointer;
}

.container .label {
  display: inline-flex;
  font-size: 14px;
  font-weight: normal;
}

.labelName {
  margin: 1px 0 0 10px;
}

.rightRadio {
  margin-left: 25px;
}
</style>
